import FlameIcon from '~/assets/icons/Flame';
import { formatNumberToK } from '~/utils/numbers';

type Props = {
  count: number;
};

const ProductNotificationCount = ({ count }: Props) => {
  return (
    <div className="flex mt-2 w-full px-3 py-2 justify-center items-center gap-1 bg-purple-hola-super-light">
      <FlameIcon width={16} height={16} />
      <p className="text-purple-hola text-xs font-normal lg:hidden text-nowrap">
        {formatNumberToK(count)} notifications set
      </p>
      <p className="text-purple-hola text-xs font-normal hidden lg:block text-nowrap">
        {formatNumberToK(count)} notifications set in the last 7 days
      </p>
    </div>
  );
};

export default ProductNotificationCount;
